import Model from "../Model";

class Representantidtops extends Model{

    buildUrl ({ param }) {
        return ['/employeeview/topuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Representantidtops;